<script setup lang="ts">
import { useOnline } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

import AppIcon from '@/components/ui/AppIcon.vue'

const online = useOnline()
const { t } = useI18n()
</script>

<template>
  <p
    v-if="!online"
    class="fixed inset-x-0 top-0 z-50 flex items-center justify-center gap-x-2 bg-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-950"
    role="status"
  >
    <AppIcon name="wifi-off" size="sm" />
    {{ t('states.offlineHint') }}
  </p>
</template>
